import React, { memo, useContext, useMemo } from 'react';
import { Avatar, Tabs } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import styles from './style.less';
import { playSound } from '@/utils/sound';
import { Category } from '@/models/category';
import { Card } from '@/models/card';
import limitX from '@/utils/imgUtils';
import { POSConfigContext } from '@/components/LayoutPOS';
import { getDefaultIfUndefined } from '@/utils/common';

const Tab: React.FC<{
  cardList: Card[];
  categoryList: Category[];
  selectedTabKey: string;
  onSelectedTabKeyChange: (key: string) => void;
}> = ({ cardList, categoryList, selectedTabKey, onSelectedTabKeyChange }) => {
  const {
    config: { uiConfig },
  } = useContext(POSConfigContext);
  const [{ assetsPrefix }] = useContext(BaseInfoContext);
  const isHorizontalMode = uiConfig.coSkuAreaDisplayMode === `horizontal`;
  const showCateIcon = getDefaultIfUndefined(uiConfig.coShowCateIcon, true);

  const tabItems = useMemo(() => {
    return [
      cardList && cardList.length
        ? {
            key: 'card',
            label: (
              <>
                {showCateIcon && <CreditCardOutlined style={{ marginRight: 5 }} />}
                套餐卡
              </>
            ),
          }
        : null,
    ]
      .concat(
        categoryList.map(category => {
          return {
            key: `${category.id}`,
            label: (
              <>
                {category.iconUrl && showCateIcon && (
                  <Avatar
                    src={`${assetsPrefix}${category.iconUrl}${limitX(50)}`}
                    style={{ marginRight: 5 }}
                    size={24}
                    draggable={false}
                  />
                )}
                {category.name}
              </>
            ),
          };
        })
      )
      .filter(Boolean);
  }, [cardList, categoryList]);

  return (
    <>
      {isHorizontalMode ? (
        <div className={styles.customTabs}>
          {cardList && cardList.length && (
            <div
              className={`${styles.customTabsItem} ${
                selectedTabKey === 'card' ? styles.active : ''
              }`}
              onClick={() => {
                playSound('flip');
                onSelectedTabKeyChange(`card`);
              }}>
              {showCateIcon && <CreditCardOutlined style={{ marginRight: 5 }} />}
              套餐卡
            </div>
          )}
          {categoryList.map(category => (
            <div
              key={category.id}
              className={`${styles.customTabsItem} ${
                selectedTabKey === `${category.id}` ? styles.active : ''
              }`}
              onClick={() => {
                playSound('flip');
                onSelectedTabKeyChange(`${category.id}`);
              }}>
              {category.iconUrl && showCateIcon && (
                <Avatar
                  src={`${assetsPrefix}${category.iconUrl}${limitX(50)}`}
                  style={{ marginRight: 5, flexShrink: 0 }}
                  size={24}
                  draggable={false}
                />
              )}
              <div className={styles.customTabsItemName}>{category.name}</div>
            </div>
          ))}
        </div>
      ) : (
        <Tabs
          onTabClick={key => {
            playSound('flip');
            onSelectedTabKeyChange(key);
          }}
          activeKey={`${selectedTabKey}`}
          centered
          size={'large'}
          className={styles.skuAreaTab}
          items={tabItems}
        />
      )}
    </>
  );
};

export default memo(Tab);
